export const newsReducer = (state = {}, action) => {
  switch (action.type) {
    case "GET_NEWS_LIST_REQUEST": {
      return {
        ...state,
        loading: true,
        news: null,
      };
    }
    case "GET_NEWS_LIST_SUCCESS": {
      return {
        ...state,
        loading: false,
        news: action.payload,
      };
    }
    case "GET_NEWS_LIST_FAILED": {
      return {
        ...state,
        loading: false,
        news: action.payload,
      };
    }
    case "ADD_NEWS_REQUEST": {
      return {
        ...state,
        loading: true,
        news: null,
      };
    }
    case "ADD_NEWS_SUCCESS": {
      return {
        ...state,
        loading: false,
        news: action.payload,
      };
    }
    case "ADD_NEWS_FAILED": {
      return {
        ...state,
        loading: false,
        news: action.payload,
      };
    }
    case "EDIT_NEWS_REQUEST": {
      return {
        ...state,
        loading: true,
        news: null,
      };
    }
    case "EDIT_NEWS_SUCCESS": {
      return {
        ...state,
        loading: false,
        news: action.payload,
      };
    }
    case "EDIT_NEWS_FAILED": {
      return {
        ...state,
        loading: false,
        news: action.payload,
      };
    }
    case "VIEW_NEWS_REQUEST": {
      return {
        ...state,
        loading: true,
        singleNews: null,
      };
    }
    case "VIEW_NEWS_SUCCESS": {
      return {
        ...state,
        loading: false,
        news: action.payload,
      };
    }
    case "VIEW_NEWS_FAILED": {
      return {
        ...state,
        loading: false,
        singleNews: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
